<template>
  <div id="app">
    <a-modal :width="800" v-model="visible" :footer="null" @cancel="visible=false">
      <div class="modal_view">
        <div class="textarea">
          <div id="showDiv0" class="showDiv0">
            <div v-for="(item,i) in indexList">
              {{ i + 1 }}
            </div>
          </div>
          <a-textarea
            v-model="textValue"
            onfocus="focus()"
            @input="monitorInput"
            placeholder="Please enter your Printbelle tracking number (starting with PB) Multiple numbers shoud be separated by comma, space or enter">
          </a-textarea>
          <div id="showDiv1" class="showDiv1">
            <div v-for="(item,i) in indexList" @click="clearSingle(i)">
              <a-icon type="close"/>
            </div>
          </div>
          <div class="numLimit">
            <span style="margin-right: 10px;cursor: pointer" @click="clearAll()"
                  v-if="indexList.length>0">Clear all</span>
            <span>{{ indexList.length }}/50</span>
          </div>
        </div>
        <div class="btn" @click="searchValue(1)">
          <a-icon type="search" style="font-size: 25px;margin-right: 6px"/>
          Track
        </div>
      </div>
    </a-modal>
    <div class="container">
      <header>
        <div class="logo_view">
          <img src="../assets/logo.png" alt="logo" @click="toHome" style="width: 41px;height: 41px">
          <img src="../assets/logo1.png" alt="logo" @click="toHome" style="width: 144px;height: 22px">
          <span>Fulfillment</span>
        </div>
        <a-tabs :default-active-key="activeKey"
                v-model="activeKey"
                @change="callback"
                :tabBarStyle="{ borderBottom: 'unset' }">
          <a-tab-pane
            v-for="item in types"
            :key="item.key"
            :tab="item.name">
          </a-tab-pane>
        </a-tabs>
        <div class="login_btn">
          <img src="../assets/login.png" style="width: 30px;height: 30px"/>
          <span @click="goLogin()">Login</span>
        </div>
      </header>
      <main>
        <div class="home">
          <div class="home_view">
            <img class="indeBgi2" src="../assets/indeBgi2.png" alt="indeBgi2" style="width: 903px;height: 268px">
            <h1>TRACK & TRACE PLATFORM</h1>
            <h6>
              Please
              <a @click="goLogin()">Login</a> to be able to trace up 500 tracking numbers.
            </h6>
            <div style="display: flex;width: 945px;margin: 0 auto">
              <div class="search">
                <div class="leftDiv">
                  <a-input
                    @click="visible=true"
                    onfocus="blur()"
                    v-model="inputValue"
                    placeholder="Please enter your Printbelle tracking number (starting with PB)."/>
                </div>
                <div class="rightDiv">
                  <div class="btn" @click="searchValue(0)">
                    <a-icon type="search" style="font-size: 25px;margin-right: 6px"/>
                    Track
                  </div>
                </div>
                <p @click="LastQuery" v-if="cacheContent!==null"
                   style="font-size: 14px; height: 20px; position: absolute; bottom: -45px; left: 15px; font-family: Arial, Helvetica, sans-serif; cursor: pointer;">
                <span
                  style="background: #152235; color: rgb(255, 255, 255); border-radius: 15px; padding: 3px 15px;"> {{
                    getCacheContent()
                  }} </span>
                </p>
              </div>
              <div class="search" style="width: 150px;margin: 35px auto">
                <img src="../assets/track2.jpg" @click="goToTrack()"
                     style="margin: 10px auto;cursor: pointer;border-radius: 38px"/>
              </div>
            </div>

          </div>
        </div>
      </main>

    </div>
  </div>
</template>

<script>
import {tCopyContent} from '../utils/utils'

export default {
  name: 'Index',
  data () {
    return {
      visible: false,
      activeKey: 0,
      textValue: '',
      indexList: [],
      inputValue: '',
      cacheContent: '',
      contentList: [],
      types: [
        {
          key: 0,
          name: 'Home',
        },
        {
          key: 1,
          name: 'Parcel Tracking',
        }
      ],
    }
  },
  created () {
  },
  methods: {
    tCopyContent,
    monitorInput () {
      this.contentList = this.textValue.split(/[\n,' ]/).filter(val => val !== '')
      this.inputValue = this.contentList.join(',')
    },
    getCacheContent () {
      let content = []
      this.cacheContent = localStorage.getItem('cacheContent')
      if (this.cacheContent != null) {
        content = this.cacheContent.split(',')
      }
      return content.length === 1 ? content[0] : 'Last query record'
    },
    toHome () {
      this.$router.push({name: 'AboutUs'})
    },
    callback () {
      this.$router.push({path: '/parcelTracking'})
    },
    goLogin () {
      window.open('https://www.printbelle.com/', '_blank')
    },
    goToTrack () {
      window.open('https://www.17track.net/?utm_medium=logistics&utm_source=PB速递', '_blank')
    },
    searchValue (type) {
      let empty = type === 0 ? this.inputValue : this.textValue
      if (empty === '') {
        return this.$message.error('Please enter your tracking number.')
      }

      this.inputValue = this.textValue.replace(/\n/g, ',')
      this.contentList = this.inputValue.split(/[\n,' ]/).filter(val => val !== '')
      if (this.contentList.length > 50) {
        return this.$message.error(' A maximum of 50 numbers allowed per time.')
      }
      let number = 0
      this.contentList.forEach((item, index) => {
        if (item.length > 50) {
          number = index + 1
        }
      })
      if (number > 0) {
        this.indexList = this.contentList
        return this.$message.error(`The${number} line is longer than 50 characters`)
      }
      const map = new Map()
      let values = this.inputValue.split(',')
      let value = values.filter(key => !map.has(key) && map.set(key, 1)).join(',')
      localStorage.setItem('cacheContent', value)
      this.cacheContent = localStorage.getItem('cacheContent')
      this.visible = false
      this.$router.push({name: 'ParcelTracking', query: {id: value}, params: {type: 1}})
    },
    LastQuery () {
      this.$router.push({name: 'ParcelTracking', query: {id: this.cacheContent}, params: {type: 2}})
    },
    clearAll () {
      this.indexList = []
      this.textValue = ''
      if (this.activeKey === 0) {
        this.inputValue = ''
      }
    },
    clearSingle (i) {
      this.indexList.splice(i, 1)
      this.textValue = this.indexList.join(',').replace(/,/g, '\n')
      this.contentList = this.inputValue.split(/[\n,' ]/).filter(val => val !== '')
      if (this.activeKey === 0) {
        this.inputValue = this.indexList.join(',').replace(/,/g, '\n')
      }
    }
  },
}
</script>


<style lang="less">

.ant-modal-wrap {
  top: 245px;
}

.ant-modal-body {
  padding: 10px;
  background: #9bbdb4;
  border-radius: 5px;
}

.modal_view {
  display: flex;
  height: 303px;
  align-items: flex-end;

  .textarea {
    width: 620px;
    height: 303px;
    position: relative;

    .ant-input {
      height: 303px;
      max-height: 303px;
      min-height: 303px;
      padding: 20px 70px 20px 38px;
      font-size: 14px;
      line-height: 30px;
      font-weight: bold;
    }

    .showDiv0 {
      left: 0;
      top: 21px;
      width: 35px;
      list-style: none;
      text-align: center;
      font-size: 14px;
      line-height: 30px;
      font-weight: bold;
      position: absolute;
      z-index: 10;
    }

    .showDiv1 {
      width: 12px;
      height: 12px;
      padding-top: 7px;
      list-style: none;
      font-size: 14px;
      line-height: 30px;
      font-weight: bold;
      position: absolute;
      right: 45px;
      top: 12px;
    }

    .numLimit {
      position: absolute;
      bottom: 10px;
      right: 25px;
      font-weight: 500;
      font-size: 16px;
      color: #999;
    }

  }


  .btn {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 65px;
    cursor: pointer;
    font-size: 26px;
    font-family: Humanst521 BT;
    font-weight: bold;
    color: #FFFFFF;
    background: linear-gradient(135deg, #FFBF0B, #EF8201);
    border-radius: 0 5px 5px 0;
  }
}

.container {
  width: 100%;
  height: 100%;

  header {
    display: flex;
    align-items: center;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    justify-content: space-between;
    height: 70px;
    width: 100%;
    min-width: 1900px;
    padding: 0 47px;
    background-color: #152235;

    .logo_view {
      width: 395px;
      display: flex;
      height: 70px;
      align-items: center;

      img {
        margin-right: 18px;
      }

      span {
        font-size: 17px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #C9C8C8;
        margin-left: 50px;
      }
    }

    .login_btn {
      width: 395px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: right;
      height: 70px;

      span {
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        font-weight: bold;
        margin-left: 10px;
        color: #C9C8C8;
      }
    }

    .ant-tabs-ink-bar {
      background-color: transparent;
    }

    .ant-tabs-bar {
      margin: 0;
    }

    .ant-tabs-tab {
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
    }

    .ant-tabs-tab-active {
      color: #FFB400;
    }

    .ant-tabs-tab:hover {
      color: #FFB400;
    }
  }

  main {
    .home {
      width: 100%;
      min-width: 1900px;
      position: absolute;
      background-image: url(../assets/indeBgi.jpg);
      background-size: 100% 100%;
      top: 70px;
      bottom: 0;
      left: 0;

      .home_view {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        h1 {
          font-weight: 700;
          font-size: 56px;
          text-align: center;
          margin-top: 52px;
          line-height: 41px;
          text-transform: capitalize;
          color: #FFFFFF;
        }

        h6 {
          font-weight: bold;
          font-size: 20px;
          margin-top: 22px;
          line-height: 23px;
          text-align: center;
          color: #535353;

          a {
            color: #FFB400;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .indeBgi2 {
          margin-top: 25px;
        }


      }
    }

    .search {
      width: 775px;
      height: 94px;
      margin-top: 35px;
      background: #7B63F1;
      position: relative;
      border-radius: 47px;

      .leftDiv {
        float: left;
        height: 100%;
        width: 615px;
        padding: 8px 0 8px 10px;
        position: relative;
        overflow: hidden;

        .ant-input {
          height: 100%;
          font-size: 16px;
          color: #929292;
          padding-left: 30px;
          background: #FFFFFF;
          box-shadow: 0 4px 3px 0 rgba(74, 74, 74, 0.2);
          border-radius: 38px 0 0 38px;
        }
      }

      .rightDiv {
        width: 160px;
        height: 100%;
        padding: 8px 10px 8px 0;
        float: right;
        position: relative;

        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          cursor: pointer;
          font-size: 26px;
          font-family: Humanst521 BT;
          font-weight: bold;
          color: #FFFFFF;
          background: linear-gradient(135deg, #FFBF0B, #EF8201);
          border-radius: 0 38px 38px 0;
        }
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue